import { render } from "./Scoreboard.vue?vue&type=template&id=28eeffc5"
import script from "./Scoreboard.vue?vue&type=script&lang=ts"
export * from "./Scoreboard.vue?vue&type=script&lang=ts"

import "./Scoreboard.vue?vue&type=style&index=0&id=28eeffc5&lang=css"
script.render = render

export default script